













































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getAccountList, accountDel } from '@/api/admin'
import AccountForm from './accountForm.vue'
import conFirm from './confirm.vue'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'

@Component({
  components: {
    AccountForm,
    conFirm
  }
})
export default class Study extends ViewBase {
  loading = true

  errMsg = ''

  list: any = []

  title = ''

  classList: any = []

  pagination: any = {}

  columns: any = []

  lang = {}

  doc: any = null

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  created() {
    this.doc = window.document
    this.lang = this.i18n.vStudy
    this.fetch()
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.lesson,
        className: 'lessonName',
        dataIndex: 'title'
      },
      {
        title: lang.teacher,
        className: 'nickname',
        dataIndex: 'nickname'
      }, {
        title: lang.class,
        className: 'class_name',
        dataIndex: 'class_name'
      },
      {
        title: lang.test,
        dataIndex: 'client_num'
        // className:css.colnum,
      },
      {
        title: lang.start,
        dataIndex: 'start_time'
      },
      // {
      //   title: lang.end,
      //   className: 'wid185',
      //   dataIndex: 'end_time'
      // },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter wid260',
        scopedSlots: { customRender: 'operation' }
      }
    ]
  }
  search(val: any) {
    const params: any = {}
    params.keyword = val
    this.fetch(params)
  }
  onClassChange(val: any) {
    const params: any = {}
    params.classId = val
    this.fetch(params)
  }
  toData(id: any) {
    this.$router.push({
      name: 'studyHistoryData',
      params: {
        id: id + ''
      }
    })
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    this.loading = true
    try {
      const res = await post('/api/cate/reviewList', params)
      if (res && res.data) {
        const data = res.data
        this.loading = false
        const pagination: any = { ...this.pagination }
        // Read total count from server
        // pagination.total = data.totalCount;
        pagination.total = data.total
        this.loading = false
        this.list = data.list
        this.pagination = pagination
        this.classList = data.classList
      }
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
